import { 
    SHOW_SUCCESS_SNACKBAR, 
    HIDE_SUCCESS_SNACKBAR, 
    SHOW_DANGER_SNACKBAR, 
    HIDE_WARNING_SNACKBAR, 
    SHOW_WARNING_SNACKBAR, 
    HIDE_DANGER_SNACKBAR, 
    SHOW_DEFAULT_SNACKBAR, 
    HIDE_DEFAULT_SNACKBAR 
} from "./actionTypes";

export const showSuccess = message => ({
    type: SHOW_SUCCESS_SNACKBAR,
    message
});

export const hideSuccess = () => ({
    type: HIDE_SUCCESS_SNACKBAR
});

export const showWarning = message => ({
    type: SHOW_WARNING_SNACKBAR,
    message
});

export const hideWarning = () => ({
    type: HIDE_WARNING_SNACKBAR
});

export const showDanger = message => ({
    type: SHOW_DANGER_SNACKBAR,
    message
});

export const hideDanger = () => ({
    type: HIDE_DANGER_SNACKBAR
});

export const showDefault = message => ({
    type: SHOW_DEFAULT_SNACKBAR,
    message
});

export const hideDefault = () => ({
    type: HIDE_DEFAULT_SNACKBAR
});